module.exports = __webpack_public_path__ + "img/TS6101-304.244956e0.jpg";